
import React from "react";
import SearchBar from "@/components/businesses/BusinessSearch";

interface EventSearchBarProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  handleSearch: (e: React.FormEvent) => void;
  className?: string;
}

const EventSearchBar: React.FC<EventSearchBarProps> = ({
  searchTerm,
  setSearchTerm,
  handleSearch,
  className
}) => {
  return (
    <SearchBar
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      handleSearch={handleSearch}
      placeholder="Search events, categories, or descriptions..."
      buttonText="Find Events"
      className={className || "max-w-xl mb-8"}
    />
  );
};

export default EventSearchBar;
